import React, { useMemo } from "react";
import Dropzone from "react-dropzone";
import { withTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faCircleNotch, faTimes } from "@fortawesome/free-solid-svg-icons";
import BaseDialog from "../../../../../components/dialogs/baseDialog/BaseDialog";
import {Alert} from "react-bootstrap";

//TODO: Check duplicate code
class UploadFileDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      files: []
    };

    this.baseStyle = {
      flex: 1,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      padding: "20px",
      borderWidth: 2,
      borderRadius: 2,
      borderColor: "#eeeeee",
      borderStyle: "dashed",
      backgroundColor: "#fafafa",
      color: "#bdbdbd",
      outline: "none",
      transition: "border .24s ease-in-out"
    };

    this.activeStyle = {
      borderColor: "#2196f3"
    };

    this.acceptStyle = {
      borderColor: "#00e676"
    };

    this.rejectStyle = {
      borderColor: "#ff1744"
    };

    this.onSubmit = this.onSubmit.bind(this);
    this.humanReadableFileSize = this.humanReadableFileSize.bind(this);
  }

  async onSubmit(files) {
    files = files.map(f => {
      f["status"] = 0;
      return f;
    });
    this.setState({ files });
    const uploadedFiles = await this.props.onSubmit(files);
    this.setState({ uploadedFiles });
  }

  humanReadableFileSize(size) {
    const labels = ["B", "KB", "MB", "GB"];
    let ct = 0;
    while (size > 1024 && ct < labels.length) {
      size /= 1024;
      ct++;
    }
    return `${Math.round(size * 100) / 100} ${labels[ct]}`;
  }

  render() {
    const { t } = this.props;
    const fileState = [
      <FontAwesomeIcon key={1} icon={faCircleNotch} pulse className="color-black mr-2" />,
      <FontAwesomeIcon key={2} icon={faCheck} className="color-green mr-2" />,
      <FontAwesomeIcon key={3} icon={faTimes} className="color-red mr-2" />
    ];
    return (
      <BaseDialog
        show={this.props.show}
        onHide={this.props.onHide}
        title={t("SingleExamination.ExaminationFilesTab.UploadModal.Title")}
        noFooter={true}
        dialogApiError={this.props.dialogApiError}
        body={(<Dropzone onDrop={this.onSubmit}>
          {({
              getRootProps,
              getInputProps,
              isDragActive,
              isDragAccept,
              isDragReject
            }) => {
            const style = useMemo(
              () => ({
                ...this.baseStyle,
                ...(isDragActive ? this.activeStyle : {}),
                ...(isDragAccept ? this.acceptStyle : {}),
                ...(isDragReject ? this.rejectStyle : {})
              }),
              [isDragActive, isDragReject, isDragAccept]
            );

            return (
              <>
                {this.props.examination.instanceTemplate.type === 2 ? (
                    <Alert key="2" variant="warning">
                        <b>
                          {t(
                              "SingleExamination.ExaminationFilesTab.UploadModal.AllowedFileTypes"
                          )}
                          :</b> PDF
                    </Alert>
                ) : ""}
                <section className="container">
                  <div {...getRootProps({ style })}>
                    <input {...getInputProps()} />
                    <p>
                      {" "}
                      {t(
                          "SingleExamination.ExaminationFilesTab.UploadModal.DragNDropBody"
                      )}
                    </p>
                  </div>
                  <aside>
                    {this.state.files.length === 0 ? (
                        <div className="mt-3">
                          <b>
                            {" "}
                            {t(
                                "SingleExamination.ExaminationFilesTab.UploadModal.Files"
                            )}
                          </b>
                          <br />
                          <span>
                        {" "}
                            {t(
                                "SingleExamination.ExaminationFilesTab.UploadModal.NoFilesUploaded"
                            )}
                      </span>
                        </div>
                    ) : (
                        <div className="mt-3">
                          <b>
                            {" "}
                            {t(
                                "SingleExamination.ExaminationFilesTab.UploadModal.Files"
                            )}
                          </b>
                          <ul style={{ listStyle: "none", padding: "0px" }}>
                            {this.state.files.map((f, idx) => (
                                <li key={idx}>
                                  {fileState[f.status]}
                                  <b>{f.name}:</b>{" "}
                                  {this.humanReadableFileSize(f.size)}
                                </li>
                            ))}
                          </ul>
                        </div>
                    )}
                  </aside>
                </section>
              </>
            );
          }}
        </Dropzone>)}
      />
    );
  }
}

export default withTranslation()(UploadFileDialog);
